module.exports = __webpack_public_path__ + "img/konbini-techno.36ffa000.svg";